export default __webpack_public_path__ + "static/media/img-0724-estonia-half-face.4cf5efb7.png";